import { Loader, RingProgress, Text } from "@mantine/core";
import { useDesktopDatabaseSync } from "../../../router/hooks";
import { Flex } from "../../../styled";
import { useTheme } from "../../../hooks";

const SyncingLoader = () => {
  const theme = useTheme();
  const { isLoadingVisible, progress } = useDesktopDatabaseSync();
  if (!isLoadingVisible) return null;
  return (
    <Flex align="center" gap={5}>
      <Loader size="sm" color={theme.colors.main[2]} />
      <Text c={theme.colors.main[2]}>{`${progress}%`}</Text>
    </Flex>
  );
};
export default SyncingLoader;
